/* eslint-disable no-unused-vars */
import { Form } from 'antd';
import styles from './searchGroup.less?modules';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import ButtonML from '@/components/button_ml/ButtonML';
import SelectML from '@/components/select_ml/SelectML';
import DatePickerML from '@/components/input_all_ml/date_picker_search_ml/DatePickerSearchML';
import { useDispatch, useSelector } from 'dva';
import { useEffect, useCallback, useState } from 'react';

const SearchGroup = (props) => {
  const [form] = Form.useForm();
  const [diagramNameOption, setDiagramNameOption] = useState([]);
  const [versionList, setVersionList] = useState([]);
  const [disabled, setDisabled] = useState(true);

  const bizData = useSelector((state) => state.dvm.approvalList);
  const dispatch = useDispatch();
  const onFinish = (values) => {
    for (let key in values) {
      if (!values[key]) {
        values[key] = undefined;
      }
    }
    props.setParamsFun(values);
  };
  const getApprovalList = useCallback(() => {
    dispatch({
      type: 'dvm/getApprovalList',
    });
  }, [dispatch]);
  useEffect(() => {
    getApprovalList();
  }, [getApprovalList]);
  useEffect(() => {
    if (!bizData) {
      return;
    }
    let diagramOptionUnuse = [];
    bizData &&
      bizData.length > 0 &&
      bizData.forEach((item) => {
        diagramOptionUnuse.push({
          name: item.diagramName,
          value: item.strategyCode,
        });
      });
    setDiagramNameOption(diagramOptionUnuse);
  }, [bizData]);

  // 重置版本号
  const resetFiledVersion = () => {
    let fileValues = form.getFieldValue();
    fileValues.version = undefined;
    form.setFieldsValue({
      ...fileValues,
    });
  };
  const selectDecision = (a, e) => {
    resetFiledVersion();
    if (e) {
      dispatch({
        type: 'dvm/getVersion',
        payload: {
          values: {
            diagramName: e.children,
          },
        },
        callback: (res) => {
          let result = [];
          res &&
            res.forEach((item) => {
              result.push({ value: item, name: item });
            });
          setVersionList(result);
          setDisabled(false);
        },
      });
    } else {
      setDisabled(true);
    }
  };

  const reset = () => {
    form.resetFields();
  };

  const typeOption = [
    { name: 'TEST', value: 'TEST' },
    { name: 'PROD', value: 'PROD' },
  ];

  const stateOption = [
    { name: 'RUNNING', value: 'RUNNING' },
    { name: 'FINISHED', value: 'FINISHED' },
    { name: 'EXCEPTION', value: 'EXCEPTION' },
    { name: 'TIMEOUT', value: 'TIMEOUT' },
  ];

  return (
    <Form
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      {/* 版本号 */}
      <div className={styles.input_contain}>
        <SelectML
          height="37px"
          inputWidth="170px"
          maxWidth="170px"
          labelwidth="130px"
          labelVal="决策图名称"
          placeVal="请选择决策图名称"
          name="strategyCode"
          allowClear={true}
          option={diagramNameOption}
          onChange={selectDecision}
        />
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="170px"
          labelVal="版本号"
          placeVal="请选择版本号"
          name="version"
          allowClear={true}
          disabled={disabled}
          option={versionList}
        />
        <SingInputML
          height="37px"
          labelwidth="130px"
          maxWidth="154px"
          labelVal="用户编号"
          placeVal="请输入用户编号"
          name="userNo"
          allowClear={true}
          // icon={}
        />
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="170px"
          labelVal="类型"
          placeVal="请选择类型"
          name="type"
          allowClear={true}
          option={typeOption}
        />
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="170px"
          labelVal="状态"
          placeVal="请选择状态"
          name="state"
          allowClear={true}
          option={stateOption}
        />

        {/* 创建时间(起始) */}
        <DatePickerML
          height="37px"
          labelwidth="130px"
          labelVal="创建时间(起始)"
          placeVal="请选择开始时间"
          name="createTimeBegin"
          inputWidth="170px"
          maxWidth="170px"
        />

        {/* 创建时间(结束) */}
        <DatePickerML
          height="37px"
          labelwidth="130px"
          labelVal="创建时间(结束)"
          placeVal="请选择结束时间"
          name="createTimeEnd"
          inputWidth="170px"
          maxWidth="170px"
        />
      </div>

      <div className={styles.btn_contain}>
        <ButtonML size="large" value="查询" htmlType="submit" fontsize="16px" />
        <ButtonML size="large" value="重置" onClick={reset} fontsize="16px" />
      </div>
    </Form>
  );
};

export default SearchGroup;
